
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./im30.cjs.production.min.js')
} else {
  module.exports = require('./im30.cjs.development.js')
}
